import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { UserState } from '../../shared/user-state/user.state';
import { InitializationService } from "../services/initialization.service";

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  private router = inject(Router);
  private store = inject(Store);
  private initializationService = inject(InitializationService);

  canActivate(): boolean {
    const userIsLoggedIn = this.store.selectSnapshot(UserState.isLoggedIn);
    if (!userIsLoggedIn) {
      const isSpecialPageToAllow = this.initializationService.isTargetUrlSpecialPages();
      if (isSpecialPageToAllow) {
        return true;
      }

      this.router.navigateByUrl('/auth/login').then();
      return false;
    }
    return true;
  }
}
